/**
 * @generated SignedSource<<d79e117fb8ca958897bf6355b8e6b8fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ExpenseCategory = "CONSULTING_AND_ADMINISTRATION" | "HARDWARE_AND_EQUIPMENT" | "INFRASTRUCTURE" | "INSURANCE" | "MEMBERSHIPS_AND_DONATIONS" | "OTHER" | "SERVICES_AND_LICENSES" | "TRAVEL" | "VEHICLES" | "%future added value";
export type AssignSupplierExpenseCategoryInput = {
  expenseCategory: ExpenseCategory;
  id: string;
};
export type SuppliersViewAssignCategoryMutation$variables = {
  input: AssignSupplierExpenseCategoryInput;
};
export type SuppliersViewAssignCategoryMutation$data = {
  readonly assignSupplierExpenseCategory: {
    readonly expenseCategory: ExpenseCategory | null | undefined;
    readonly id: string;
  };
};
export type SuppliersViewAssignCategoryMutation = {
  response: SuppliersViewAssignCategoryMutation$data;
  variables: SuppliersViewAssignCategoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Supplier",
    "kind": "LinkedField",
    "name": "assignSupplierExpenseCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expenseCategory",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SuppliersViewAssignCategoryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SuppliersViewAssignCategoryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5e61d58b8cb3b2c9c34202c364034e2e",
    "id": null,
    "metadata": {},
    "name": "SuppliersViewAssignCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation SuppliersViewAssignCategoryMutation(\n  $input: AssignSupplierExpenseCategoryInput!\n) {\n  assignSupplierExpenseCategory(input: $input) {\n    id\n    expenseCategory\n  }\n}\n"
  }
};
})();

(node as any).hash = "a0018340eef23bb5987277d96681a777";

export default node;
